import { HydroPowerIcon } from './HydroPowerIcon';

/**
 * author: Hans Böhm
 * id 97D5D644-DB37-4DA8-8B37-444B242A88EF
 * name hydro-power
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hydro-power.svg
 * tags
 * - Device / Tech 
 * - Agriculture 
 */
export const HydraulicTurbineIcon = HydroPowerIcon;
export default HydraulicTurbineIcon